import { IParamState, useUrlPersistentPostcode } from './useUrlPersistentPostcode';
import { ICustomerData } from '../../../../common/model/ICustomerData';
import useCustomerStorage from '../hooks/useCustomerStorage';

export default function useGetPostCode(): string | null {
  const { getUrlPostcode } = useUrlPersistentPostcode();
  const { param: paramsPostcode }: IParamState = getUrlPostcode();
  const { customerStorage } = useCustomerStorage();

  const customerData: ICustomerData = customerStorage.getCustomerData();

  if (paramsPostcode) {
    const code = Array.isArray(paramsPostcode) ? paramsPostcode[0] : paramsPostcode;
    return code || null;
  } else if (customerData && customerData.postcode) {
    return customerData.postcode;
  }

  return null;
}
